import { render, staticRenderFns } from "./IeMoney.vue?vue&type=template&id=27665f2a&scoped=true&"
import script from "./IeMoney.vue?vue&type=script&lang=js&"
export * from "./IeMoney.vue?vue&type=script&lang=js&"
import style0 from "./IeMoney.vue?vue&type=style&index=0&id=27665f2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27665f2a",
  null
  
)

export default component.exports